import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { makeStyles } from "@mui/styles";
import usePlacesProxy from "../hooks/usePlacesProxy";

const useStyles = makeStyles({
    root: {
        position: "relative",
    },
    dropdown: {
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: 4,
        marginTop: 2,
        boxShadow: "0 4px 6px -1px rgba(0,0,0,.1), 0 2px 4px -1px rgba(0,0,0,.06)",
        listStyle: "none",
        padding: 0,
        margin: 0,
    },
    item: {
        padding: "8px 12px",
        fontSize: 14,
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#f7fafc",
        },
    },
    itemActive: {
        backgroundColor: "#ebf8ff",
    },
    main: {
        fontWeight: 500,
    },
    secondary: {
        fontSize: 12,
        color: "#888",
        marginLeft: 4,
    },
});

function GoogleAutoCompleteField(props) {
    const { onPlaceSelected, ...rest } = props;
    const classes = useStyles();
    const [localValue, setLocalValue] = useState(rest.value || "");

    const {
        suggestions,
        showSuggestions,
        activeIndex,
        fetchSuggestions,
        selectPlace,
        clearSuggestions,
        handleKeyDown,
        containerRef,
    } = usePlacesProxy({
        onPlaceSelected,
        options: {
            types: ["geocode"],
            componentRestrictions: { country: ["us", "ca"] },
        },
    });

    useEffect(() => {
        if (rest.value !== undefined) {
            setLocalValue(rest.value);
        }
    }, [rest.value]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setLocalValue(newValue);
        fetchSuggestions(newValue);
        if (rest.onChange) {
            rest.onChange(e);
        }
    };

    const handleSuggestionClick = async (prediction) => {
        clearSuggestions();
        await selectPlace(prediction);
    };

    return (
        <Form.Group
            size="lg"
            id="address_autocomplete_section"
            className={classes.root}
            ref={containerRef}
        >
            <Form.Control
                {...rest}
                value={localValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                autoComplete="off"
            />
            <Form.Label className="floating-label">
                {rest.placeholder}
            </Form.Label>

            {showSuggestions && suggestions.length > 0 && (
                <ul className={classes.dropdown}>
                    {suggestions.map((prediction, index) => (
                        <li
                            key={prediction.place_id}
                            className={`${classes.item} ${index === activeIndex ? classes.itemActive : ""}`}
                            onMouseDown={() => handleSuggestionClick(prediction)}
                        >
                            <span className={classes.main}>
                                {prediction.structured_formatting?.main_text}
                            </span>
                            <span className={classes.secondary}>
                                {prediction.structured_formatting?.secondary_text}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </Form.Group>
    );
}

export default GoogleAutoCompleteField;
